import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#007BFF',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        green: '#00A90F',
        red: '#DF0A00',
        white: '#FFFFFF',
        red30:'#EC6C66',
        green30: '#77D480',
        blue: '#0000F2',
        blue10:'#22D4EB'
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
});
